<template>
    <BInputGroup>
        <BInputGroupPrepend>
            <BButton variant="outline-secondary" @click="changeExpression">{{
                expr_symbol
            }}</BButton>
        </BInputGroupPrepend>
        <BFormInput
            class="rounded-0 px-0"
            type="search"
            :value="currentValue"
            number
            lazy
            v-bind="$attrs"
            @input="update_qbe"
            @blur="blurred"
            @keydown.enter="refilter"
            v-on="inputListeners"
        ></BFormInput>
    </BInputGroup>
</template>

<script>
import {
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
} from "bootstrap-vue";
import FilterInputMixin from "./FilterInputMixin.js";

export default {
    name: "OFilterNumberField",
    components: {
        BInputGroup,
        BInputGroupPrepend,
        BButton,
        BFormInput,
    },
    mixins: [FilterInputMixin],
    data() {
        return {
            expression: "eq",
            expressions: [
                { code: "eq", text: "=" },
                { code: "gt", text: ">" },
                { code: "lt", text: "<" },
                { code: "ge", text: ">=" },
                { code: "le", text: "<=" },
            ],
        };
    },
};
</script>
